export const getHashdata = (fullHash, hashname) => {
    const hashData = fullHash.substring(1) // Remove the "#" character
        .split('&') // Split the hash fragment into key-value pairs
        .reduce((acc, pair) => {
            const [key, value] = pair.split('=');
            acc[key] = value;
            return acc;
        }, {});
    return hashData[hashname];
}